/**
 * 重新上傳可接受的副檔名。
 *
 * input 的 accept 只是選檔視窗的提示，不是驗證：使用者可以切到「所有檔案」繞過，
 * 而且 .pptx / .docx / .xlsx 在 macOS 的 UTI 裡都歸屬 public.zip-archive，
 * 只要 accept 含 .zip 它們就會變成可選。沒有這層檢查的話，選到非模型檔會被原樣
 * 當成 GLB 送上 S3、產生壞掉的模型，而且過程中不會有任何錯誤。
 */

/** 單檔上傳只收這三種 */
export const SINGLE_FILE_MODEL = /\.(glb|gltf|zip)$/i;

/** 多檔上傳時，每個檔案都必須是 .gltf 或它的伴隨檔（.bin 與貼圖） */
export const GLTF_COMPANION = /\.(bin|png|jpe?g|webp|ktx2|gltf)$/i;

/** 這批檔案能不能送進上傳流程 */
export function isAcceptableUpload(files) {
    const list = Array.from(files);
    if (list.length === 0) return false;
    if (list.length === 1) return SINGLE_FILE_MODEL.test(list[0].name);
    return list.every((file) => GLTF_COMPANION.test(file.name));
}
